module.exports = __webpack_public_path__ + "img/re.01fea3b6.svg";